import { CrudMode, Grid, ValidationErrors, useElementBreakpoints } from "@compass/core";
import {
  ContributorMatch,
  ContributorMatchEditResource,
  ContributorMatchViewResource,
  Permission,
} from "generated/openApi";

import produce from "immer";
import "moment-timezone";
import { BasicInfo } from "./BasicInfo";
import { MatchFiles } from "./MatchFiles/MatchFiles";
import { SideInfo } from "./SideInfo";

export const ContributorMatchPageBody = (props: {
  rootPermission: Permission;
  crudMode: CrudMode;
  match: ContributorMatch;
  setMatch: (value: ContributorMatch) => void;
  viewResource: ContributorMatchViewResource;
  editResource: ContributorMatchEditResource;
  validationErrors: ValidationErrors | string[];
  onEdit?: () => void;
  hideContributor?: boolean | undefined;
  hideEmployment?: boolean | undefined;
  canSendUnallowableEmail?: boolean;
  willSendUnallowableEmail?: boolean;
  setWillSendUnllowableEmail?: (value: boolean) => void;
}) => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();
  const showSideInfo = props.match.id > 0;

  return (
    <Grid ref={breakpointsRef} container spacing="md">
      <Grid item xs={setBreakpoints({ md: showSideInfo ? 8 : 12, xs: 12 })} pr={2}>
        <BasicInfo
          crudMode={props.crudMode}
          match={props.match}
          setMatch={props.setMatch}
          viewResource={props.viewResource}
          editResource={props.editResource}
          validationErrors={props.validationErrors}
          hideContributor={props.hideContributor}
          hideEmployment={props.hideEmployment}
          canSendUnallowableEmail={props.canSendUnallowableEmail}
          willSendUnallowableEmail={props.willSendUnallowableEmail}
          setWillSendUnllowableEmail={props.setWillSendUnllowableEmail}
        />
      </Grid>

      {showSideInfo && (
        <Grid
          item
          xs={setBreakpoints({ md: 4, xs: 12 })}
          borderLeft={1}
          borderColor={(theme) => theme.palette.border.main}
        >
          <SideInfo match={props.match} viewResource={props.viewResource} />
        </Grid>
      )}

      <Grid item xs={setBreakpoints({ xs: 12 })}>
        <MatchFiles
          rootPermission={props.rootPermission}
          id={props.match.id}
          matchFiles={props.match.files || []}
          setMatchFiles={(matchFiles) => {
            props.setMatch(
              produce(props.match, (draft) => {
                draft.files = matchFiles;
              })
            );

            props.onEdit?.();
          }}
        />
      </Grid>
    </Grid>
  );
};
